// frontend_react/src/services/adminApi.js

import api, { buildCompanyScopeHeaders } from "./api";

// ===============================
// Restaurant categories
// ===============================

export const getRestaurantCategories = () =>
  api.get("/admin/restaurant/categories");

export const createRestaurantCategory = (payload) =>
  api.post("/admin/restaurant/categories", payload);

export const updateRestaurantCategory = (uuid, payload) =>
  api.put(`/admin/restaurant/categories/${uuid}`, payload);

export const deleteRestaurantCategory = (uuid) =>
  api.delete(`/admin/restaurant/categories/${uuid}`);


// ===============================
// Restaurant menu items
// ===============================

export const getRestaurantItems = () =>
  api.get("/admin/restaurant/items");

export const createRestaurantItem = (payload) =>
  api.post("/admin/restaurant/items", payload);

export const updateRestaurantItem = (uuid, payload) =>
  api.put(`/admin/restaurant/items/${uuid}`, payload);

export const deleteRestaurantItem = (uuid) =>
  api.delete(`/admin/restaurant/items/${uuid}`);


// ===============================
// Users
// ===============================

export const getUsers = ({ companyUuid } = {}) =>
  api.get("/admin/users", {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const createUser = (payload) =>
  api.post("/admin/create_user", payload);

export const updateUser = (uuid, payload, { companyUuid } = {}) =>
  api.put(`/admin/users/${uuid}`, payload, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const deleteUser = (uuid, { companyUuid } = {}) =>
  api.delete(`/admin/users/${uuid}`, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const resendUserPasswordLink = (uuid, { companyUuid } = {}) =>
  api.post(
    `/admin/users/${uuid}/send-password-link`,
    {},
    {
      headers: buildCompanyScopeHeaders(companyUuid),
    }
  );

export const getUserCompanyAccesses = (uuid, { companyUuid } = {}) =>
  api.get(`/admin/users/${uuid}/company-accesses`, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const updateUserCompanyAccesses = (uuid, payload, { companyUuid } = {}) =>
  api.put(`/admin/users/${uuid}/company-accesses`, payload, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const checkCompanyExists = (name, signal) =>
  api.get("/admin/check_company", {
    params: { name },
    signal,
  });

// ===============================
// Clients
// ===============================

export const getClients = ({ companyUuid } = {}) =>
  api.get("/admin/clients", {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const createClient = (payload, { companyUuid } = {}) =>
  api.post("/admin/create_client", payload, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const updateClient = (uuid, payload, { companyUuid } = {}) =>
  api.put(`/admin/clients/${uuid}`, payload, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const deleteClient = (uuid, { companyUuid } = {}) =>
  api.delete(`/admin/clients/${uuid}`, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

// ===============================
// Fidélité
// ===============================

export const updateLoyaltyProgram = (programUuid, payload) =>
  api.put(`/loyalty/programs/${programUuid}`, payload);

export const activateLoyaltyProgram = (programUuid) =>
  api.post(`/loyalty/programs/${programUuid}/activate`);

export const deactivateLoyaltyProgram = (programUuid) =>
  api.post(`/loyalty/programs/${programUuid}/deactivate`);

export const archiveLoyaltyProgram = (programUuid) =>
  api.post(`/loyalty/programs/${programUuid}/archive`);


// ===============================
// Companies
// ===============================

export const getCompanies = () =>
  api.get("/admin/companies");

export const createCompany = (payload) =>
  api.post("/admin/companies", payload);

export const updateCompany = (uuid, payload) =>
  api.put(`/admin/companies/${uuid}`, payload);

export const deleteCompany = (uuid) =>
  api.delete(`/admin/companies/${uuid}`);
export const fetchLoyaltyPrograms = () =>
  api.get("/loyalty/programs");

export const createLoyaltyProgram = (payload) =>
  api.post("/loyalty/programs", payload);

export const fetchLoyaltyAccounts = (
  params = {},
  { companyUuid } = {}
) =>
  api.get("/loyalty/accounts", {
    params,
    headers:
      buildCompanyScopeHeaders(
        companyUuid
      ),
  });

export const fetchLoyaltyBenefits = (
  params = {},
  { companyUuid } = {}
) =>
  api.get("/loyalty/benefits", {
    params,
    headers:
      buildCompanyScopeHeaders(
        companyUuid
      ),
  });

export const fetchLoyaltyTransactions = (
  params = {},
  { companyUuid } = {}
) =>
  api.get("/loyalty/transactions", {
    params,
    headers:
      buildCompanyScopeHeaders(
        companyUuid
      ),
  });

export const redeemLoyaltyBenefit = (
  benefitUuid,
  receiptUuid,
  { companyUuid } = {}
) =>
  api.post(
    `/loyalty/benefits/${benefitUuid}/redeem`,
    {
      receipt_uuid:
        receiptUuid,
    },
    {
      headers:
        buildCompanyScopeHeaders(
          companyUuid
        ),
    }
  );

export const cancelLoyaltyBenefit = (benefitUuid) =>
  api.post(`/loyalty/benefits/${benefitUuid}/cancel`);
